// extracted by mini-css-extract-plugin
module.exports =  {"root":"s_ddWHGEPJzuH92ejzne","card":"lGCEVSH4u1nin0mWzbZE","content":"BoNHjBSFtrm91NdSBU09","action":"rVgYAnV6ifX6WCatgspd","dropShadow":"HReuLsABu1zWNyhgUv1B"};